module.exports = __webpack_public_path__ + "img/icon_main_bank.92c48c2f.svg";